var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.assetUrl,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey,
    isQmod = companyVars.isQmod;

// hCaptcha
var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form.id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    }); 
}

function onInvisibleRecaptchaSubmit (token) {
    jq("form.validate-form").submit(); 
    return true;
}

// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on('click keyup', function (event) {
        if (event.type === 'keyup') {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if ((code !== 32) && (code !== 13)) {
                return false;
            }
        }
        handler.call(this, event);
    });
};

// Google Analytics
if (document.getElementById("analyticsOptions")) {
    var analyticsOptions = JSON.parse(document.getElementById("analyticsOptions").innerText);
    (function (i,s,o,g,r,a,m){i["GoogleAnalyticsObject"]=r;i[r]=i[r]||function (){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,"script","https://www.google-analytics.com/analytics.js","ga");
    
    ga("create", analyticsOptions.gaId, analyticsOptions.domain);
    
    (function () {
        var opts = {};
        var prefix = "/investors";
        if (location.hostname.indexOf("stockpr.com") === -1) {
            opts.cookiePath = location.pathname.substring(0, location.pathname.indexOf("/", 1) + 1)
            opts.page = prefix + location.pathname.substring(location.pathname.indexOf("/", 1));
        } else if (location.hostname.match(/^ir\./)) {
            opts.page = prefix + location.pathname;
        }
        ga("send", "pageview", opts);
    })();
    /**
    * Function that tracks a click on an outbound link in Analytics.
    * This function takes a valid URL string as an argument, and uses that URL string
    * as the event label. Setting the transport method to 'beacon' lets the hit be sent
    * using 'navigator.sendBeacon' in browser that support it.
    */
    var trackOutboundLink = function (url, category) {
        category = category || "outbound";
        ga("send", "event", category, "click", url, {
            "transport": "beacon"
        });
    };
    
    window.addEventListener("load", function () {
        // Add outbound link tracking in GA
        jq("a").not(".fancybox").each(function (){
            var href = jq(this).attr("href");
            if (typeof href === "undefined") return;
            if (href.indexOf("http") >= 0 &&
                (href.indexOf(website_base_url) < 0 && 
                    href.indexOf(ir_base_url) < 0 && 
                    href.indexOf("eqcdn") < 0 && 
                    href.indexOf("amazonaws") < 0
               )
           ) {
                jq(this).click(function (e) {
                    trackOutboundLink('"' + href + '"');
                });
            } else {
                // It's not an outbound link, but if it's a link to a file, we want to track that.
                if (href.match(/(\.pdf|\.jpg|\.png|\.gif|\.ppt|\.jpeg|\.mp3|\.mp4|\.wav|\.docx|\.doc|\.xsl|\.cslx)/g)) {
                    jq(this).click(function (e) {
                        trackOutboundLink('"' + href + '"', "documents-and-files");
                    });
                }
            }
        });
    });
}

// Main document ready scripts
jq(document).ready(function () {
    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
    });
    addRequiredAsteriskToLabels();
    
    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            var target = jq(this).closest(".home-hero").siblings(".module").first();
            jq("html,body").animate({
                scrollTop: target.offset().top - jq("#header").height()
            }, "slow");
        });
    }
    
    jq(".mobile-nav-trigger").click(function (){
        jq(".main-nav").css("height", "auto");
    });
    
    // Affixing
    var headerAffixOffset = 1;
    var minorAnnouncementEl = jq('.minor-announcement');
    if (minorAnnouncementEl.length) {
        headerAffixOffset = minorAnnouncementEl.outerHeight();
    }
    jq("#main-header.affixed").affix({
        offset:{
            top: headerAffixOffset
        }
    });
    var subNav = jq(".sub-navigation.affixed");
    if(subNav.length) {
        jq(subNav).affix({
            offset: { 
                top: jq(".sub-navigation").offset().top - jq("#main-header").outerHeight()
            }
        });
    }
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if(divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                    svgElm = jq(this).find(".circle"),
                    percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + "%");
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind("scroll");
            }
        });
    }

    var menuRight = document.getElementById("mobile-nav"),
    showRight = document.getElementById("showRight");
    
    if (showRight) {
        showRight.onclick = function () {
            toggleMenuKeybind();
            jq(this).toggleClass("active");
            jq("body").toggleClass("push-to-left");
            jq(menuRight).toggleClass("cbp-spmenu-open");
            disableOther("showRight");
        };
    }
    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
     function toggleMenuKeybind() {
        var $body = jq('body');    
        if ($body.hasClass('push-to-left')) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(showRight).toggleClass('active');
                    jq("body").toggleClass("push-to-left");
                    jq(menuRight).toggleClass("cbp-spmenu-open");
                    disableOther("showRight");
                    $body.off("keydown");
                }
            });
        }
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.parent());
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            }
        });
    });
    
    jq.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    }
    
    jq(".fancybox").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "600"
    });
    jq(".fancybox-sec-filing").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "900"
    });
    
    jq(".fancybox-bio").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "0"
    });
    
    jq(".fancybox-modal").fancybox({
        width: 970,
        autoSize: false,
        height: "auto"
    });
    
    jq(".fancybox\\.iframe").fancybox({
        type: "iframe",
        iframe : {
            css : {
                width : "80%",
                maxWidth: "1024px",
            }
        }
    });
    
    //Bootstrap Select
    jq(".selectpicker").selectpicker({
        iconBase: "DIN",
        tickIcon: "no-icon"
    });
    
    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e){
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq("#sec-filing-filter select").on("change", function (e) {
        jq(this).closest("form").submit(); 
    });
    
    // Media listing filters - auto submit form. Submitting rather than rebuilding
    // the query string keeps whatever is in the search box alongside the year.
    jq(".listing-filters select").on("change", function (e) {
        jq(this).closest("form").submit();
    });
    
    var $filterSelect = jq(".year-filter .selectpicker");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".year-filter .selectpicker").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + "?year=" + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
    
    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }
    
    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
    	jq(this).next(".spr-expandable").toggle("blind");
    });
    
    // Crisis Messaging
    var $majorAnnouncement = jq('#majorAnnouncement');
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            jq.fancybox.open({
                src: '#majorAnnouncement',
                type: 'inline',
                touch: window.outerWidth < 768,
                beforeLoad: function () {
                    // Add an aria-label to the modal
                    var fancyboxContainer = jq.fancybox.getInstance().$refs.container;
                    fancyboxContainer.attr('aria-label', 'Announcement');
                },
                afterLoad: function () {
                    // Remove main content visibility to screen readers
                    jq('.general-wrapper').attr('aria-hidden', true);
                },
                afterClose: function () {
                    jq('.general-wrapper').attr('aria-hidden', false);
                }
            });
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }
}); // end document.ready

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required").siblings("label").each(function () {
        var currentText = jq(this).text();
        jq(this).text(currentText + "*");
    });
}

//Smooth scroll to
function goToByScroll(id, callback) {
    jq("html,body").animate({
        scrollTop: jq(id).offset().top
    }, "slow", "swing", callback);
}
jq(".smooth").click(function () {
    goToByScroll(jq(this).attr("href"));
    return false;
});

// Checkbox Groups
var update_sec_checkboxes = function () {
    if (jq("#ir-sec-all").is(":checked")) {
        jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
    } else {
        jq(".ir-sec-sub").prop("disabled", false).prop("checked", false);
    }
}
jq("#ir-sec-all").change(update_sec_checkboxes);
if (jq("#ir-sec-all").is(":checked")) {
    jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
}

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                  var point = jq(this).find(".point");
                  jq(this).css("height", point.outerHeight()/1.2);
                });
        }
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}